import { createSelector } from "reselect";

export {
	mapSettingsSelector,
	persistedState,
	profileState,
	widgetStateSelector,
	disabledFeedsSelector,
	layerOpacitySelector,
	activityFiltersSelector,
	eventFiltersSelector,
	eventTemplateFiltersSelector,
	getFloorPlanEntitiesByType,
	sitePlanEntitiesSelector
} from "../Persisted/selectors";

// Map
export {
	mapState,
	mapObject,
	activeEntitiesSelector,
	inEditGeo,
	replayMapObject,
	replayMapState,
	activeReplayEntitiesSelector,
	mapStateSelector,
	mapSelector
} from "../Map/selectors";
export { mapLayersState } from "../MapLayers/selectors";

// Camera Dock
export {
	cameraDockSelector,
	dockDataSelector,
	dockOpenSelector,
	dockedCamerasSelector
} from "../../Dock/Cameras/selectors";

// Global appState
export { globalState, trackHistoryDuration } from "../Global/selectors";

// Fullscreen Camera Dialog
export { fullscreenCameraOpen } from "../Dialog/selectors";

const selectActiveFOVs = (state) => state?.appState?.persisted?.activeFOVs;

export const selectValidActiveFOVKeys = createSelector([selectActiveFOVs], (activeFOVs) => {
	if (!activeFOVs) return [];

	return Object.entries(activeFOVs)
		.filter(([_, fov]) => fov !== null && typeof fov === "object")
		.map(([key]) => key);
});
